import React, { useState } from "react";
import "../Styling/Checkout.css";
import checkoutimg from "../assets/Checkoutimg.jfif";
import { Country, State } from "country-state-city";
import { useDispatch, useSelector } from "react-redux";
import { SaveShippingInfo } from "../Redux/Actions/cartActions";
import CheckoutSteps from "../components/CheckoutSteps";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../UrlHelper/baseUrl";

const Checkout = () => {
  const { shippingInfo } = useSelector((state) => state.cartData);
  const { cartItems, loading } = useSelector((state) => state.cartData);
  const [city, setCity] = useState(shippingInfo.city);
  const [country, setCountry] = useState(shippingInfo.country);
  const [address, setAddress] = useState(shippingInfo.address);
  const [pinCode, setPinCode] = useState(shippingInfo.pinCode);
  const [phoneNo, setPhoneNo] = useState(shippingInfo.phoneNo);
  const [state, setState] = useState(shippingInfo.state);
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gotra, setGotra] = useState("");


  const dispatch = useDispatch();
  const navigate = useNavigate();
const userId = localStorage.getItem("userId");
  const SaveShippingHandler = async (e) => {
    e.preventDefault();

    if (phoneNo.length < 10 || phoneNo.length > 10) {
      toast.error("Phone Number should be 10 digits Long!!");
      return;
    }

    // Save shipping info to Redux
    const shippingData = { address, city, state, country, pinCode, phoneNo, name, gotra, age };
    dispatch(SaveShippingInfo(shippingData));

    // Transform cartItems to the desired format
    const orders = cartItems.map((item) => ({
      productId: item.productId,
      quantity: item.quantity,
      productSize: item.productSize,
      price: item.price,
    }));

    // Calculate total price
    const totalPrice = orders.reduce((acc, item) => acc + item.price * item.quantity, 0);

    // Combine shipping info and orders into checkoutData
    const checkoutData = {
      orders,
      totalPrice,
      address: shippingData.address,
      city: shippingData.city,
      country: shippingData.country,
      postCode: shippingData.pinCode,
      phoneNumber: shippingData.phoneNo,
      name: shippingData.name,
      age: shippingData.age,
      gotra: shippingData.gotra,
      state: shippingData.state,
      userId
    };

    console.log("Final Checkout Data:", checkoutData);

    try {
      const response = await axios.post(`${baseUrl}/admin-orders`, checkoutData, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("API Response -------------------------------------:", response);
      console.log("Order ID:", response);
      localStorage.setItem("ShippingId", response?.data?._id);
      if (response.status === 201) {
        // toast.success("Order placed successfully!");
        // localStorage.removeItem("cartItems");
        navigate("/cart/order-confirm");

      }
    } catch (error) {
      toast.error("Failed to place order. Please try again.");
      console.error("Checkout Error:", error.response?.data?.message || error.message);
    }
  };


  return (
    <>
      <div className="container p-5">
        <div className="row d-flex justify-content-start align-items-center ">
          <CheckoutSteps activeStep={0} />
          {/* <div className="col-lg-5 col-10">
            <div className="pb-5 mt-5">
              <img src={checkoutimg || "../assets/Checkoutimg.jfif"} alt="Shipping Details" title="Shipping Details" className="login-image" />
            </div>
          </div> */}
          <div className="col-lg-8 offset-lg-2 col-md-6 offset-md-3">
            <div className="mt-1 mt-md-5">
              <h1 className="login-system-register">Shipping Details</h1>

              <form
                className="pt-4"
                encType="multipart/form-data"
                onSubmit={SaveShippingHandler}
              >
                {/* Name */}
                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Name</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your Full Name"
                    className="login-input"
                  />
                </div>

                {/* Age */}
                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Age</label>
                  <input
                    type="number"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    placeholder="Enter your Age"
                    className="login-input"
                  />
                </div>

                {/* Gotra */}
                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Gotra</label>
                  <input
                    type="text"
                    value={gotra}
                    onChange={(e) => setGotra(e.target.value)}
                    placeholder="Enter your Gotra"
                    className="login-input"
                  />
                </div>

                {/* Existing Fields */}
                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Your Address</label>
                  <textarea
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Enter Full Address"
                    className="login-input"
                  />
                </div>

                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Your City</label>
                  <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="Enter your City Name"
                    className="login-input"
                  />
                </div>

                <div className="d-flex flex-column pb-3">
                  <label htmlFor="country" className="login-text">
                    Your Country
                  </label>
                  <select
                    id="country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    className="login-input"
                  >
                    <option value="">Select your Country Name</option>
                    {Country &&
                      Country.getAllCountries().map((data) => (
                        <option key={data.isoCode} value={data.isoCode}>
                          {data.flag} &nbsp;
                          {data.name}
                        </option>
                      ))}
                  </select>
                </div>

                {country && (
                  <div className="d-flex flex-column pb-3">
                    <label htmlFor="state" className="login-text">
                      Your State
                    </label>
                    <select
                      id="state"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      className="login-input"
                    >
                      <option value="">Select your State Name</option>
                      {State &&
                        State.getStatesOfCountry(country).map((data) => (
                          <option key={data.isoCode} value={data.isoCode}>
                            {data.name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Post Code</label>
                  <input
                    type="number"
                    className="login-input"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                    placeholder="Enter your City Pin Code"
                  />
                </div>

                <div className="d-flex flex-column pb-3">
                  <label className="login-text">Phone Number</label>
                  <input
                    type="number"
                    className="login-input"
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)}
                    placeholder="Enter Valid Phone Number"
                    size="10"
                  />
                </div>

                <button className="login-button mt-4">
                  <span>Continue</span>
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
